"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndicesSection = void 0;
var aon_tws_common_ui_1 = require("@aon/aon-tws-common-ui");
var lodash_1 = __importDefault(require("lodash"));
var React = __importStar(require("react"));
var contentConstants_1 = __importDefault(require("../../../contentConstants"));
var SharedComponents_1 = require("./SharedComponents");
var IndicesSection = /** @class */ (function (_super) {
    __extends(IndicesSection, _super);
    function IndicesSection(props) {
        var _this = _super.call(this, props) || this;
        _this.getCrumbs = function () {
            var _a = _this.props, indicesItems = _a.indicesItems, indices = _a.indices;
            var crumbs = indices.map(function (indice) {
                var indiceItem = lodash_1.default.find(indicesItems, function (item) { return item.name === indice; });
                if (indiceItem) {
                    return { value: indiceItem.name, displayText: indiceItem.displayText };
                }
                return {};
            });
            return crumbs;
        };
        _this.handleUpdateIndices = function (values) {
            var onIndicesChange = _this.props.onIndicesChange;
            if (onIndicesChange) {
                onIndicesChange(values);
            }
        };
        _this.handleRemoveIndices = function (values) {
            var indices = lodash_1.default.map(values, function (c) { return c.value; });
            var onRemoveIndices = _this.props.onRemoveIndices;
            if (onRemoveIndices) {
                onRemoveIndices(indices);
            }
        };
        return _this;
    }
    IndicesSection.prototype.render = function () {
        var _a = this.props, disabled = _a.disabled, indicesItems = _a.indicesItems, indices = _a.indices;
        return (React.createElement(SharedComponents_1.InnerSectionContainer, { className: 'tws-indices-section', label: contentConstants_1.default.SUBSECTIONHEADERS_INDICES },
            React.createElement(aon_tws_common_ui_1.Select, { selectSize: 'lg', dropdownSize: 'lg', disabled: disabled, displayText: contentConstants_1.default.CUSTOM_QUESTION_INDICES_DISPLAY_TEXT, keepDisplayText: true, placeHolderText: contentConstants_1.default.INPUT_PLACEHOLDER_SEARCH_INDICES, selectedValues: indices, items: indicesItems, showCount: true, multiple: true, showApplyButton: true, onApply: this.handleUpdateIndices }),
            indices && indices.length > 0 && (React.createElement(SharedComponents_1.CrumblistContainer, { enableDismiss: true, data: this.getCrumbs(), update: this.handleRemoveIndices }))));
    };
    IndicesSection.defaultProps = {
        indicesItems: [],
        indices: [],
    };
    return IndicesSection;
}(React.Component));
exports.IndicesSection = IndicesSection;
